module.exports = __webpack_public_path__ + "img/seed1.e375cdc4.png";